/* eslint-disable max-len */
import {DEFAULT_TIMEOUT, setErrorApi} from '@/utils/constants';
import {useAxios} from '@sttedra_ui/framework';
import {handleErrorCustom} from '@/utils/errorHandling';

// #region Globals
const {base} = useAxios();
const servicio = '/Version';
// #endregion

async function getVersion() {
  const url = `${servicio}`;
  try {
    const {data: response} = await base.get(url, {timeout: DEFAULT_TIMEOUT});
    return response.objetoSalida;
  } catch (error) {
    if (error.code === 'ERR_NETWORK') setErrorApi();
    handleErrorCustom(error);
  }
}

export {
  getVersion,
};
